/**
 * @module sendGraph
 * @alias Fiverr._logEventToGraphite
 * @since 2.0.0
 */

import { alias } from '../../__alias';

/**
 * @typedef   MonitoringObject
 * @type      {Object}
 * @property  {String} options.label            Key of the table
 * @property  {Number} [options.timing]         Value for timers in milliseconds
 * @property  {Number} [options.value]          Value for counters
 * @property  {Number} [options.percentage=5]   Percentage of events to actually send
 * @property  {Number} [options.ttl=300]        Time to delay between reports (milliseconds)
 */

/**
 * Report statistical data. Aliases Fiverr._logEventToGraphite
 * @param {MonitoringObject} options Data for the report
 * no return value
 *
 * @example
 * sendGraph({
 *   label: 'fe_events.flow_name.interaction',
 *   percentage: 100,
 * })
 *
 * sendGraph({
 *   label: 'fe_events.flow_name.process',
 *   timing: 2000,
 *   percentage: 100,
 * })
 */
export const sendGraph = alias('_logEventToGraphite');
